module.exports = __webpack_public_path__ + "static/media/Karan Acoustics Master Collection Stereo A Power Amplifier.d917c490.jpg";